// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file tournament/v1/tournament_api.proto (package tournament.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp } from "@bufbuild/protobuf";
import { Tournament, TournamentRequest } from "./tournament_pb.js";
import { User } from "../../base/v1/user_pb.js";
import { TournamentRequestState } from "../../base/v1/tournament_request_state_pb.js";

/**
 * @generated from message tournament.v1.AddTournamentRequest
 */
export const AddTournamentRequest = /*@__PURE__*/ proto3.makeMessageType(
  "tournament.v1.AddTournamentRequest",
  () => [
    { no: 1, name: "tournament", kind: "message", T: Tournament },
  ],
);

/**
 * @generated from message tournament.v1.AddTournamentResponse
 */
export const AddTournamentResponse = /*@__PURE__*/ proto3.makeMessageType(
  "tournament.v1.AddTournamentResponse",
  [],
);

/**
 * @generated from message tournament.v1.ListTournamentsRequest
 */
export const ListTournamentsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "tournament.v1.ListTournamentsRequest",
  () => [
    { no: 1, name: "start_date", kind: "message", T: Timestamp, opt: true },
    { no: 2, name: "end_date", kind: "message", T: Timestamp, opt: true },
  ],
);

/**
 * @generated from message tournament.v1.ListTournamentsResponse
 */
export const ListTournamentsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "tournament.v1.ListTournamentsResponse",
  () => [
    { no: 1, name: "tournaments", kind: "message", T: Tournament, repeated: true },
    { no: 2, name: "has_permission", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message tournament.v1.AddTournamentParticipationRequest
 */
export const AddTournamentParticipationRequest = /*@__PURE__*/ proto3.makeMessageType(
  "tournament.v1.AddTournamentParticipationRequest",
  () => [
    { no: 1, name: "tournament_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message tournament.v1.AddTournamentParticipationResponse
 */
export const AddTournamentParticipationResponse = /*@__PURE__*/ proto3.makeMessageType(
  "tournament.v1.AddTournamentParticipationResponse",
  [],
);

/**
 * @generated from message tournament.v1.RemoveTournamentParticipationRequest
 */
export const RemoveTournamentParticipationRequest = /*@__PURE__*/ proto3.makeMessageType(
  "tournament.v1.RemoveTournamentParticipationRequest",
  () => [
    { no: 1, name: "tournament_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message tournament.v1.RemoveTournamentParticipationResponse
 */
export const RemoveTournamentParticipationResponse = /*@__PURE__*/ proto3.makeMessageType(
  "tournament.v1.RemoveTournamentParticipationResponse",
  [],
);

/**
 * @generated from message tournament.v1.UpdateTournamentRequest
 */
export const UpdateTournamentRequest = /*@__PURE__*/ proto3.makeMessageType(
  "tournament.v1.UpdateTournamentRequest",
  () => [
    { no: 1, name: "tournament", kind: "message", T: Tournament },
  ],
);

/**
 * @generated from message tournament.v1.UpdateTournamentResponse
 */
export const UpdateTournamentResponse = /*@__PURE__*/ proto3.makeMessageType(
  "tournament.v1.UpdateTournamentResponse",
  [],
);

/**
 * @generated from message tournament.v1.DeleteTournamentRequest
 */
export const DeleteTournamentRequest = /*@__PURE__*/ proto3.makeMessageType(
  "tournament.v1.DeleteTournamentRequest",
  () => [
    { no: 1, name: "tournament_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message tournament.v1.DeleteTournamentResponse
 */
export const DeleteTournamentResponse = /*@__PURE__*/ proto3.makeMessageType(
  "tournament.v1.DeleteTournamentResponse",
  [],
);

/**
 * @generated from message tournament.v1.ListTournamentPermissionUsersRequest
 */
export const ListTournamentPermissionUsersRequest = /*@__PURE__*/ proto3.makeMessageType(
  "tournament.v1.ListTournamentPermissionUsersRequest",
  [],
);

/**
 * @generated from message tournament.v1.ListTournamentPermissionUsersResponse
 */
export const ListTournamentPermissionUsersResponse = /*@__PURE__*/ proto3.makeMessageType(
  "tournament.v1.ListTournamentPermissionUsersResponse",
  () => [
    { no: 1, name: "users", kind: "message", T: User, repeated: true },
  ],
);

/**
 * @generated from message tournament.v1.AddTournamentPermissionUserRequest
 */
export const AddTournamentPermissionUserRequest = /*@__PURE__*/ proto3.makeMessageType(
  "tournament.v1.AddTournamentPermissionUserRequest",
  () => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message tournament.v1.AddTournamentPermissionUserResponse
 */
export const AddTournamentPermissionUserResponse = /*@__PURE__*/ proto3.makeMessageType(
  "tournament.v1.AddTournamentPermissionUserResponse",
  [],
);

/**
 * @generated from message tournament.v1.RemoveTournamentPermissionUserRequest
 */
export const RemoveTournamentPermissionUserRequest = /*@__PURE__*/ proto3.makeMessageType(
  "tournament.v1.RemoveTournamentPermissionUserRequest",
  () => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message tournament.v1.RemoveTournamentPermissionUserResponse
 */
export const RemoveTournamentPermissionUserResponse = /*@__PURE__*/ proto3.makeMessageType(
  "tournament.v1.RemoveTournamentPermissionUserResponse",
  [],
);

/**
 * @generated from message tournament.v1.CreateTournamentRequestRequest
 */
export const CreateTournamentRequestRequest = /*@__PURE__*/ proto3.makeMessageType(
  "tournament.v1.CreateTournamentRequestRequest",
  () => [
    { no: 1, name: "tournament", kind: "message", T: Tournament },
    { no: 2, name: "coupon", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ],
);

/**
 * @generated from message tournament.v1.CreateTournamentRequestResponse
 */
export const CreateTournamentRequestResponse = /*@__PURE__*/ proto3.makeMessageType(
  "tournament.v1.CreateTournamentRequestResponse",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "amount", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "razorpay_order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message tournament.v1.ConfirmTournamentRequestRequest
 */
export const ConfirmTournamentRequestRequest = /*@__PURE__*/ proto3.makeMessageType(
  "tournament.v1.ConfirmTournamentRequestRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message tournament.v1.ConfirmTournamentRequestResponse
 */
export const ConfirmTournamentRequestResponse = /*@__PURE__*/ proto3.makeMessageType(
  "tournament.v1.ConfirmTournamentRequestResponse",
  [],
);

/**
 * @generated from message tournament.v1.ListTournamentRequestsRequest
 */
export const ListTournamentRequestsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "tournament.v1.ListTournamentRequestsRequest",
  () => [
    { no: 2, name: "states", kind: "enum", T: proto3.getEnumType(TournamentRequestState), repeated: true },
  ],
);

/**
 * @generated from message tournament.v1.ListTournamentRequestsResponse
 */
export const ListTournamentRequestsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "tournament.v1.ListTournamentRequestsResponse",
  () => [
    { no: 1, name: "requests", kind: "message", T: TournamentRequest, repeated: true },
  ],
);

/**
 * @generated from message tournament.v1.ProcessTournamentRequestRequest
 */
export const ProcessTournamentRequestRequest = /*@__PURE__*/ proto3.makeMessageType(
  "tournament.v1.ProcessTournamentRequestRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "state", kind: "enum", T: proto3.getEnumType(TournamentRequestState) },
    { no: 3, name: "tournament", kind: "message", T: Tournament },
  ],
);

/**
 * @generated from message tournament.v1.ProcessTournamentRequestResponse
 */
export const ProcessTournamentRequestResponse = /*@__PURE__*/ proto3.makeMessageType(
  "tournament.v1.ProcessTournamentRequestResponse",
  [],
);

